export default __webpack_public_path__ + "static/virtual-coninsa-ce537401c0e7af83225dceda54b726db.png";